<template>
  <div class="section-card pax-card">
    <snackbarcomp v-model="snackbar" :mesaj="text1"></snackbarcomp>

    <adresaradialogcustom v-model="dialogShow" :kisi="pax" @updatePassenger="updatePassenger" />
    <div class="card-header purple-bar">
      <div style="display:flex;align-items:center;gap:10px;">
        <div class="pax-number-badge">{{ index + 1 }}</div>
        <div>
          <div style="font-size:15px;font-weight:600;color:#1f2937;">
            {{ passengerType(pax.PaxType) }} {{ $t('Passenger') }}
          </div>
        </div>
        <v-btn :disabled="isUpdate" color="primary" @click="openDialog()">
          {{ $t('Passenger-Search') }} <v-icon>search</v-icon>
        </v-btn>
      </div>
      <v-checkbox @change="$emit('defaultContact', pax, index)" :disabled="isUpdate" :input-value="contactValue"
        @change.native="$emit('update:contactValue', $event.target.checked)" :label="$t('Default-Contact')"
        color="#667eea" hide-details class="mt-0 pt-0 shrink"></v-checkbox>
    </div>
    <div class="card-body">
      <v-layout row wrap>
        <v-flex xs12>

        </v-flex>

        <v-flex xs12 sm4 md3 pr-1>
          <v-select :label="$t('Gender')" :items="genderItems" item-text="text" item-value="value" v-model="pax.Gender"
            :rules="[rules.required]" :disabled="isUpdate" outline></v-select>
        </v-flex>
        <v-flex xs12 sm4 md3 pr-1>
          <v-text-field :label="$t('Name_label')" v-model="pax.FirstName"
            @change="$emit('changeFirstName', pax.FirstName)" :disabled="isUpdate" :rules="[rules.required]"
            outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 md3 pr-1>
          <v-text-field :label="$t('Surname_label')" v-model="pax.LastName"
            @change="$emit('changeLastName', pax.LastName)" :disabled="isUpdate" :rules="[rules.required]"
            outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field :label="$t('Email_label')" v-model="pax.Email" @change="$emit('changeEmail', pax.Email)"
            :disabled="isUpdate" :rules="[rules.required, rules.email]" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <v-autocomplete :label="$t('Nationality')" :items="countryItems" item-text="name" item-value="code"
            v-model="pax.Nationality" :rules="[rules.required]" :disabled="isUpdate" outline></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <tarihim :etiket="$t('Date-of-Birth')" :aktifmi="isUpdate" v-model="pax.BirthDate" :detaygizle="false"
            :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <phoneinput v-model="pax.Phone" :rules="[rules.required]" @change="$emit('changePhone', pax.Phone)"
            :disabled="isUpdate" :hideDetails="false" :label="$t('Phone')" />
        </v-flex>
        <v-flex xs12 sm6 md3 v-if="!isInternational && pax.Nationality == 'TR'">
          <v-text-field :label="$t('T-C-Identity-Number')" :disabled="isUpdate" v-model="pax.CitizenNo"
            :rules="[rules.required, rules.exactLength11]" mask="###########" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <v-autocomplete :label="$t('Wheelchair')" :items="WheelChairItems" item-text="text" item-value="value"
            v-model="pax.WheelChairService" :disabled="isUpdate" outline></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <tarihim :etiket="$t('Passport-Expiry-Date-v2')" :aktifmi="isUpdate" v-model="pax.PassportExpireDate"
            :detaygizle="false" :rules="isInternational ? [rules.required] : []"></tarihim>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <v-text-field :label="$t('Passport-Number')" v-model="pax.PassportNo" :disabled="isUpdate"
            :rules="isInternational ? [rules.required] : []" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-1>
          <v-text-field :label="$t('Mile-Card')" v-model="pax.FrequentFlayerNo" :disabled="isUpdate"
            outline></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-btn :disabled="isUpdate" color="primary" @click="adresKaydet()">{{ $t('Save-Passenger') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import phoneinput from "@/components/app/customcomp/PhoneInputNew.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import Airports from "@/components/app/satis/ucak/airports.js";
import adresaradialogcustom from "@/components/app/customcomp/adresaradialogcustom.vue";
import tool from "@/components/app/coper/tools.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp.vue";
export default {
  name: "PassengerCard",
  data() {
    return {
      dialogShow: false,
      snackbar: false,
      text1: "",
    }
  },
  components: { phoneinput, tarihim, adresaradialogcustom, snackbarcomp },
  props: {
    pax: { type: Object, required: true },
    index: { type: Number, required: true },
    isUpdate: { type: Boolean, default: false },
    contactValue: { type: Boolean, default: false },
    genderItems: { type: Array, required: true },
    countryItems: { type: Array, required: true },
    WheelChairItems: { type: Array, required: true },
    isInternational: { type: Boolean, default: false },
    rules: { type: Object, required: true }
  },
  methods: {
    passengerType(val) { return this.$t(Airports.passengerType(val)); },
    openDialog() {
      this.dialogShow = true;
    },
    updatePassenger(pax) {
      this.$emit("updatePassenger", pax, this.index);
      this.dialogShow = false;
    },
    adresKaydet() {
      var endpoint = this.pax.CoperKisiID ? 'AdresUpdate' : 'AdresInsert';
      var credentials = JSON.parse(
        window.localStorage.getItem("credentials")
      );
      var params = {
        Value: {
          Id: this.pax.CoperKisiID,
          Ad: this.pax.FirstName,
          Soyad: this.pax.LastName,
          SirketNo: credentials.CoperSirketNo,
          Cinsiyet: this.pax.Gender === "Male" ? 1 : 2,
          Ulke: this.pax.Nationality,
          PasaportNo: this.pax.PassportNo,
          BitisTarihi: this.pax.PassportExpireDate,
          Uyruk: this.pax.Nationality,
          GSM: this.pax.Phone,
          TCKimlikNo: this.pax.CitizenNo,
          Email: this.pax.Email,
          DogumTarihi: this.pax.BirthDate,
          MileCard:this.pax.FrequentFlayerNo,
          TekerlekliSandalye:this.pax.WheelChairService,
        },
      };
      tool.http_post(this, endpoint, params).then(
        (response) => {
          this.loadingcomp = false;
          if (response.body.Status == true) {
            this.text1 = "Kayıt Eklendi";
            this.snackbar = true;
            this.$emit("afterSave", response.body.data);
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.loadingcomp = false;
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );

    }
  }
};
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

.pax-number-badge {
  width: 28px;
  height: 28px;
  background: #667eea;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>